import client from './client';

export const authApi = {
  login: (email: string, password: string) =>
    client.post('/api/admin/auth/login', { email, password }),

  getProfile: () =>
    client.get('/api/account/profile'),
};
